import React from 'react';
import { CaseStudyOverview } from 'src/containers/CaseStudyOverview';

export default function DrawerCaseStudyOverview() {
  return <CaseStudyOverview />
}
